export const getDisplayUnit = (unit: string | null | undefined) =>
  units[`${unit}`]?.abbr || unit || ''

export const getMathUnit = (unit: string | null | undefined) => units[`${unit}`]?.math || undefined

export const units: {
  [unit: string]: {
    abbr?: string
    math?: string
  }
} = {
  metrePerSecondSquared: {
    abbr: 'm/s²',
    math: 'm / s^2'
  },
  degreeOfArc: {
    abbr: '°',
    math: 'deg'
  },
  squareCentimetre: {
    abbr: 'cm²',
    math: 'cm^2'
  },
  revolutionPerSecond: {
    abbr: 'rps',
    math: '1 / s'
  },
  revolutionPerMinute: {
    abbr: 'rpm',
    math: '1 / mins'
  },
  squareMetre: {
    abbr: 'm²',
    math: 'm^2'
  },
  ampere: {
    abbr: 'A',
    math: 'A'
  },
  microampere: {
    abbr: 'µA',
    math: 'uA'
  },
  milliampere: {
    abbr: 'mA',
    math: 'mA'
  },
  kilogramPerCubicMetre: {
    abbr: 'kg/m³',
    math: 'kg / m^3'
  },
  gramPerCubicMetre: {
    abbr: 'ppm',
    math: 'g / m^3'
  },
  kilowattHour: {
    abbr: 'kWh',
    math: 'kW h'
  },
  metre: {
    abbr: 'm',
    math: 'm'
  },
  mile: {
    abbr: 'mi',
    math: 'mi'
  },
  centimetre: {
    abbr: 'cm',
    math: 'cm'
  },
  millimetre: {
    abbr: 'mm',
    math: 'mm'
  },
  kilometre: {
    abbr: 'km',
    math: 'km'
  },
  kilogram: {
    abbr: 'kg',
    math: 'kg'
  },
  gram: {
    abbr: 'g',
    math: 'g'
  },
  milligram: {
    abbr: 'mg',
    math: 'mg'
  },
  kilogramPerHour: {
    abbr: 'kg/h',
    math: 'kg / h'
  },
  watt: {
    abbr: 'W',
    math: 'W'
  },
  kilowatt: {
    abbr: 'kW',
    math: 'kW'
  },
  megawatt: {
    abbr: 'MW',
    math: 'MW'
  },
  kilowattHourPerYear: {
    abbr: 'kWh/year',
    math: 'kW h / year'
  },
  pascal: {
    abbr: 'Pa',
    math: 'Pa'
  },
  kilopascal: {
    abbr: 'kPa',
    math: 'kPa'
  },
  poundPerSquareInch: {
    abbr: 'psi',
    math: 'psi'
  },
  bar: {
    abbr: 'bar',
    math: 'bar'
  },
  millibar: {
    abbr: 'mbar',
    math: 'mbar'
  },
  decibel: {
    abbr: 'dB',
    math: 'decibel'
  },
  kelvin: {
    abbr: 'K',
    math: 'K'
  },
  degreeCelsius: {
    abbr: '°C',
    math: 'degC'
  },
  degreeFahrenheit: {
    abbr: '°F',
    math: 'degF'
  },
  hour: {
    abbr: 'h',
    math: 'h'
  },
  minute: {
    abbr: 'min',
    math: 'min'
  },
  second: {
    abbr: 's',
    math: 's'
  },
  percent: {
    abbr: '%',
    math: '%'
  },
  metrePerSecond: {
    abbr: 'm/s',
    math: 'm / s'
  },
  metrePerHour: {
    abbr: 'm/h',
    math: 'm / h'
  },
  kilometrePerHour: {
    abbr: 'km/h',
    math: 'km / h'
  },
  milePerHour: {
    abbr: 'mph',
    math: 'mi / h'
  },
  volt: {
    abbr: 'V',
    math: 'V'
  },
  cubicMetre: {
    abbr: 'm³',
    math: 'm^3'
  },
  litre: {
    abbr: 'l',
    math: 'l'
  },
  millilitre: {
    abbr: 'ml',
    math: 'ml'
  },
  litrePerSecond: {
    abbr: 'l/s',
    math: 'l / s'
  },
  litrePerHour: {
    abbr: 'l/h',
    math: 'l / h'
  },
  gallonPerMinute: {
    abbr: 'GPM',
    math: 'gal / mins'
  },
  megaGallonPerDay: {
    abbr: 'MGD',
    math: 'Mgal / days'
  },
  byte: {
    abbr: 'B',
    math: 'B'
  },
  kibibyte: {
    abbr: 'kB',
    math: 'KiB'
  },
  mebibyte: {
    abbr: 'MB',
    math: 'MiB'
  },
  eur: {
    abbr: '€',
    math: 'EUR'
  },
  usd: {
    abbr: '$',
    math: 'USD'
  },
  foot: {
    abbr: 'ft'
  },
  inch: {
    abbr: 'in'
  },
  inchesOfWater: {
    abbr: 'inH2O'
  },
  inchesOfMercury: {
    abbr: 'inHg'
  },
  tonne: {
    abbr: 't'
  },
  voltAmpere: {
    abbr: 'VA'
  },
  voltAmpereReactive: {
    abbr: 'var'
  },
  kiloVoltAmpere: {
    abbr: 'kVA'
  },
  kiloVoltAmpereReactive: {
    abbr: 'kvar'
  }
}
